'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _FormValidationService = require('./../../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _editContactphoneModal = require('./edit.contactphone.modal.html');

var _editContactphoneModal2 = _interopRequireDefault(_editContactphoneModal);

var _editContactemailModal = require('./edit.contactemail.modal.html');

var _editContactemailModal2 = _interopRequireDefault(_editContactemailModal);

var _angularUiRouter = require('angular-ui-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditController = function () {
  function EditController($scope, $stateParams, $state, $timeout, entityService, appConfig, loadingService, $uibModal, $ngConfirm, customFormsService, growl, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EditController);

    this.closeModal = function () {
      this.$uibModalInstance.close();
    };

    this._$scope = $scope;
    this._$state = $state;
    this._$timeout = $timeout;
    this._$uibModal = $uibModal;
    this._entityService = entityService;
    this._appConfig = appConfig;
    this.formValidationService = new _FormValidationService2.default();
    this.loadingService = loadingService;
    this.$ngConfirm = $ngConfirm;
    this.customFormsService = customFormsService;
    this.growl = growl;
    this.enums = enums;

    this.searchEntityUrl = appConfig.apiServiceBaseUri + 'api/entity/search/';

    this.params = {};
    if (this.entityManagement && (0, _keys2.default)(this.entityManagement).length) {
      (0, _assign2.default)(this.params, this.entityManagement);
    } else {
      (0, _assign2.default)(this.params, $stateParams);
    }

    this.entityType = this.params.entityType;
    this.entityId = this.params.entityId;

    this.initializeEntity();

    this.tempPhone = {
      phoneType: "1",
      phone: ""
    };
    this.addPhoneError = '';

    this.tempEmail = "";
    this.addEmailError = '';

    this.state = '';

    this.panels = {
      entityDetails: true,
      addressDetails: true,
      contactPerson: true
    };

    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';

    this.getWebPublisherList();
    this.getStockProviderList();
  }

  (0, _createClass3.default)(EditController, [{
    key: 'initializeEntity',
    value: function initializeEntity() {
      var _this = this;

      var editCtrl = this;

      editCtrl.entity = {
        parentId: editCtrl.params.parent.entityId > 0 ? editCtrl.params.parent.entityId : null,
        parent: {
          name: editCtrl.params.parent.entityId > 0 ? editCtrl.params.parent.entityName : null
        },
        address: {},
        entityType: editCtrl.params.entityType,
        contactPerson: {
          title: "1"
        },
        contactPhones: [],
        contactEmails: [],
        entityUsers: [],
        lookupProviderType: "1",
        webPublisherType: "1",
        imageUrl: '/images/location.png'
      };

      editCtrl.configureForm();

      if (editCtrl.params.entityId) {
        editCtrl.loadingService.showLoading('editEntity', 'Loading Entity ...');

        editCtrl._entityService.getEntity(editCtrl.params.entityId).then(function (response) {
          (0, _assign2.default)(editCtrl.entity, response.data);
          editCtrl.entity.parent.name = response.data.parentName;
          if (editCtrl.entity.contactPerson) {
            editCtrl.entity.contactPerson.title = editCtrl.entity.contactPerson.title.toString();
          } else {
            editCtrl.entity.contactPerson = { title: "1" };
          }
          editCtrl.entity.lookupProviderType = editCtrl.entity.lookupProviderType.toString();

          //Entity Metas
          var webleadFollowUpEmail = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.WebLeadFollowUpEmail;
          });
          editCtrl.entity.webLeadFollowUpEmail = _this.strToBool(webleadFollowUpEmail != null ? webleadFollowUpEmail.value : null);

          var displayInDashboard = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.DisplayInDashboard;
          });
          editCtrl.entity.displayInDashboard = displayInDashboard ? parseInt(displayInDashboard.value) : 3;

          var marketingSourceRequired = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.MarketingSourceRequired;
          });
          editCtrl.entity.marketingSourceRequired = _this.strToBool(marketingSourceRequired != null ? marketingSourceRequired.value : null);

          var telecomProviderMeta = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.TelecomProvider;
          });
          if (telecomProviderMeta != null) {
            editCtrl.entity.telecomProviderName = JSON.parse(telecomProviderMeta.value).name;
          } else {
            editCtrl.entity.telecomProviderName = "None";
          }

          var confirmedEnquiryComplianceTemplate = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.ConfirmedEnquiryComplianceTemplate;
          });
          editCtrl.entity.confirmedEnquiryComplianceTemplate = confirmedEnquiryComplianceTemplate ? confirmedEnquiryComplianceTemplate.value : null;

          var invoiceDetails = (0, _lodash.find)(editCtrl.entity.entityMeta, function (em) {
            return em.entityMetaType === _this.enums.ENTITY_META_TYPE.InvoiceDetails;
          });
          editCtrl.entity.invoice = invoiceDetails ? JSON.parse(invoiceDetails.value) : {};

          editCtrl.configureForm();
          editCtrl.setDefaults(editCtrl.entity.entityType);
        }).catch(function (err) {}).finally(function () {
          editCtrl.loadingService.hideLoading('editEntity');
        });
      } else {
        editCtrl.setDefaults(editCtrl.entity.entityType);
      }
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var editCtrl = this;

      editCtrl.formValidationService.initialize(editCtrl.entity);

      editCtrl.formValidationService.addField({
        fieldName: 'name',
        displayName: 'Name',
        required: true,
        stringLength: {
          min: 2,
          max: 50
        }
      });

      editCtrl.formValidationService.addField({
        fieldName: 'legalName',
        displayName: 'Legal Name',
        stringLength: {
          min: 2,
          max: 50
        }
      });

      editCtrl.formValidationService.addField({
        fieldName: 'website',
        displayName: 'Website',
        type: 'url',
        stringLength1: {
          min: 10,
          max: 100
        }
      });

      editCtrl.formValidationService.addField({
        fieldName: 'line1',
        displayName: 'Address Line 1',
        model: editCtrl.entity.address,
        required: true,
        stringLength: {
          min: 5,
          max: 100
        }
      });

      editCtrl.formValidationService.addField({
        fieldName: 'firstName',
        displayName: 'First Name',
        model: editCtrl.entity.contactPerson,
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      editCtrl.formValidationService.addField({
        fieldName: 'lastName',
        displayName: 'Last Name',
        model: editCtrl.entity.contactPerson,
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      if (parseInt(editCtrl.params.entityType) === 3) {
        editCtrl.formValidationService.addField({
          fieldName: 'lookupProviderUsername',
          displayName: 'Api Key',
          condition: '{MODEL}.lookupProviderEnabled',
          required: true
        });
      }
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(entityType) {
      switch (entityType.toString()) {
        case "1":
          this.setDefaultsCompany();
          break;

        case "2":
          this.setDefaultsDealer();
          break;

        case "3":
          this.setDefaultsLocation();
          break;
      }
    }
  }, {
    key: 'setDefaultsCompany',
    value: function setDefaultsCompany() {
      var prefix = this.params.entityId ? 'Edit' : 'Add';
      this.pageTitle = prefix + ' Company';
      this.searchParentDisabled = false;
    }
  }, {
    key: 'setDefaultsDealer',
    value: function setDefaultsDealer() {
      var prefix = this.params.entityId ? 'Edit' : 'Add';
      this.pageTitle = prefix + ' Dealer';
      this.searchParentDisabled = true;
    }
  }, {
    key: 'setDefaultsLocation',
    value: function setDefaultsLocation() {
      var prefix = this.params.entityId ? 'Edit' : 'Add';
      this.pageTitle = prefix + ' Location';
      this.searchParentDisabled = true;

      this.entity.autoSold = this.entity.autoSold || 0;
      this.entity.appraisalExpiry = this.entity.appraisalExpiry || 0;

      this.autoSold = {
        retail: (1 | this.entity.autoSold) === this.entity.autoSold,
        trade: (2 | this.entity.autoSold) === this.entity.autoSold
      };
    }
  }, {
    key: 'addPhone',
    value: function addPhone() {
      var _this2 = this;

      var phones = this.entity.contactPhones;

      if (!this.tempPhone.phone || this.tempPhone.phone === '') {
        this.addPhoneError = 'Please enter a phone number to add';
        return;
      }

      var phone = (0, _lodash.find)(phones, function (p) {
        return p.phone === _this2.tempPhone.phone;
      });
      if (phone) {
        this.addPhoneError = 'This phone number has already been added';
        return;
      }

      phones.push(this.tempPhone);

      this.addPhoneError = '';
      this.tempPhone = {
        "phoneType": "1",
        "phone": ""
      };

      this.closeModal();
    }
  }, {
    key: 'removePhone',
    value: function removePhone(contactPhone) {
      this.entity.contactPhones = (0, _lodash.without)(this.entity.contactPhones, contactPhone);
    }
  }, {
    key: 'addEmail',
    value: function addEmail() {
      var _this3 = this;

      var emails = this.entity.contactEmails;

      if (!this.tempEmail || this.tempEmail === '') {
        this.addEmailError = 'Please enter a valid email address to add';
        return;
      }

      var email = (0, _lodash.find)(emails, function (e) {
        return e.email === _this3.tempEmail;
      });
      if (email) {
        this.addEmailError = 'This email address has already been added';
        return;
      }

      emails.push({ 'email': this.tempEmail, 'name': this.tempName });

      this.addEmailError = '';
      this.tempEmail = "";
      this.tempName = "";

      this.closeModal();
    }
  }, {
    key: 'removeEmail',
    value: function removeEmail(contactEmail) {
      this.entity.contactEmails = (0, _lodash.without)(this.entity.contactEmails, contactEmail);
    }
  }, {
    key: 'addEntity',
    value: function addEntity() {
      var _this4 = this;

      var editCtrl = this;

      if (!editCtrl.formValidationService.validateForm()) {
        return;
      }

      this.state = 'Saving';

      editCtrl.loadingService.showLoading('editEntity', 'Saving Changes ...');

      //If Parent Selected
      if (editCtrl.entity.parent) {
        if (editCtrl.entity.parent.originalObject) {
          editCtrl.entity.parentId = editCtrl.entity.parent.originalObject.entityId;
        }

        delete editCtrl.entity.parent;
      }

      this._entityService.addEntity(this.entity).then(function (response) {
        _this4.state = 'Saved';
        editCtrl.redirectToParent();
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          editCtrl.state = 'ModelError';

          err.data.map(function (item) {
            editCtrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          editCtrl.state = 'SystemError';
          editCtrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        editCtrl.loadingService.hideLoading('editEntity');
      });
    }
  }, {
    key: 'parentSelected',
    value: function parentSelected(item) {
      if (item) {
        this.$parent.$ctrl.entity = item.originalObject.EntityId;
      }
    }
  }, {
    key: 'clearParent',
    value: function clearParent() {
      if (this.entity.parent) {
        delete this.entity.parent;
        this._$scope.$broadcast('angucomplete-alt:clearInput', 'searchCompanies');
      }
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent() {
      if (this.params.isEntityManagement) {
        return;
      }

      switch (this.entityType) {
        case "1":
          this._$state.go('admin.entity.listCompanies', { entityType: this.entityType });
          break;
        case "2":
        case "3":
          this._$state.go('admin.entity.listChildren', { entityId: this.entity.parentId, entityType: this.entityType });
          break;
      }
    }
  }, {
    key: 'updateAutoSold',
    value: function updateAutoSold(autoSoldType, modelProp) {
      if (this.autoSold[modelProp]) {
        this.entity.autoSold |= autoSoldType;
      } else {
        this.entity.autoSold &= ~autoSoldType;
      }
    }
  }, {
    key: 'addContactPhone',
    value: function addContactPhone() {
      this.openModal(_editContactphoneModal2.default);
    }
  }, {
    key: 'addContactEmail',
    value: function addContactEmail() {
      this.openModal(_editContactemailModal2.default);
    }
  }, {
    key: 'openModal',
    value: function openModal(template) {
      this.$uibModalInstance = this._$uibModal.open({
        template: template,
        scope: this._$scope
      });
    }
  }, {
    key: 'onImageUploaded',
    value: function onImageUploaded(response) {
      this.entity.imageUrl = this.mediaUrl + '/' + response.data[0].value;
    }
  }, {
    key: 'phoneTypeToString',
    value: function phoneTypeToString(phoneType) {
      switch (phoneType.toString()) {
        case "1":
          return "Work Phone";
        case "2":
          return "Home Phone";
        case "3":
          return "Work Mobile";
        case "4":
          return "Personal Mobile";
        case "5":
          return "Fax";
        case "6":
          return "Other";
      }
    }
  }, {
    key: 'getWebPublisherList',
    value: function getWebPublisherList() {
      this.webPublisherList = [];
      this.webPublisherList.push({ id: null, name: 'None' });
      this.webPublisherList.push({ id: 1, name: 'EasierAd' });
      this.webPublisherList.push({ id: 2, name: 'Stock Loader' });
    }
  }, {
    key: 'addCustomForm',
    value: function addCustomForm() {
      var _this5 = this;

      this.customFormsService.list(this.entityId).then(function (response) {
        _this5.showAddCustomForms(response.data);
      });
    }
  }, {
    key: 'showAddCustomForms',
    value: function showAddCustomForms(availableForms) {
      this._$scope.customForms = availableForms;
      this._$scope.selectedForm = null;

      this.addCustomFormDialog = this.$ngConfirm({
        title: 'Add Custom Form',
        contentUrl: 'templates/customForms/addCustomFormTemplate',
        scope: this._$scope,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: this.customFormNextStep.bind(this)
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'customFormNextStep',
    value: function customFormNextStep() {
      var _this6 = this;

      if (!this._$scope.selectedForm.settingsTemplate) {
        var customForm = {
          entityId: this.entityId,
          customFormId: this._$scope.selectedForm.customFormId,
          customFormName: this._$scope.selectedForm.name,
          settingsJson: null
        };
        this.addNewCustomForm(customForm);
        return;
      }

      this._$scope.errMsgs = null;
      this._$scope.settings = {};

      this.$ngConfirm({
        title: 'Settings for ' + this._$scope.selectedForm.name + ' Form',
        contentUrl: 'templates/customForms/' + this._$scope.selectedForm.settingsTemplate,
        scope: this._$scope,
        columnClass: 'm',
        type: 'dark',
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var settings = _this6.parseCustomFormSettings(_this6._$scope.selectedForm.parser);
              if (!settings) {
                return false;
              } else {
                var _customForm = {
                  entityId: _this6.entityId,
                  customFormId: _this6._$scope.selectedForm.customFormId,
                  customFormName: _this6._$scope.selectedForm.name,
                  settingsJson: settings,
                  settingsTemplate: _this6._$scope.selectedForm.settingsTemplate,
                  parser: _this6._$scope.selectedForm.parser
                };
                _this6.addNewCustomForm(_customForm);
              }
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'addNewCustomForm',
    value: function addNewCustomForm(customForm) {
      var _this7 = this;

      this.customFormsService.add(customForm).then(function (response) {
        _this7.entity.customForms.push(customForm);

        _this7.growl.success(customForm.customFormName + ' added successfully', { ttl: 5000 });
      }).catch(function (err) {
        alert('Could not save custom form. Something went wrong.');
      });
    }
  }, {
    key: 'showRemoveCustomForm',
    value: function showRemoveCustomForm(customForm) {
      var _this8 = this;

      this.$ngConfirm({
        title: 'Remove Custom Form',
        content: 'Are you sure want to remove this form ?',
        columnClass: 'm',
        type: 'red',
        buttons: {
          yes: {
            text: 'Yes',
            btnClass: 'btn-danger',
            action: function action() {
              _this8.customFormsService.remove(_this8.entityId, customForm.customFormId).then(function (response) {
                debugger;
                //const formToRemove = find(this.entity.customForms, o => o.customFormId === customForm.customFormId);
                (0, _lodash.remove)(_this8.entity.customForms, function (o) {
                  return o.customFormId === customForm.customFormId;
                });

                _this8.growl.success(customForm.customFormName + ' removed successfully', { ttl: 5000 });
              });
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'parseCustomFormSettings',
    value: function parseCustomFormSettings(fn) {
      if (fn === 'parseMercPerOwnedWarranty') {
        return this.parseMercPerOwnedWarranty();
      }
    }
  }, {
    key: 'parseMercPerOwnedWarranty',
    value: function parseMercPerOwnedWarranty() {
      var errMsgs = [];

      if (!this._$scope.settings.exchangePlan) {
        errMsgs.push('Exchange Plan is a required field');
      }

      if (!this._$scope.settings.salesManager) {
        errMsgs.push('Sales Manager is a required field');
      }

      if (!this._$scope.settings.serviceManager) {
        errMsgs.push('Service Manager is a required field');
      }

      if (!this._$scope.settings.partsManager) {
        errMsgs.push('Parts Manager is a required field');
      }

      if (!this._$scope.settings.warrantyPeriod) {
        errMsgs.push('Warranty Period is a required field');
      }

      if (errMsgs.length > 0) {
        this._$scope.errMsgs = errMsgs;
        return null;
      }

      return (0, _stringify2.default)(this._$scope.settings);
    }
  }, {
    key: 'showEditCustomForm',
    value: function showEditCustomForm(customForm) {
      var _this9 = this;

      this._$scope.errMsgs = null;
      this._$scope.settings = JSON.parse(customForm.settingsJson);

      this.$ngConfirm({
        title: 'Settings for ' + customForm.name + ' Form',
        contentUrl: 'templates/customForms/' + customForm.settingsTemplate,
        scope: this._$scope,
        columnClass: 'm',
        type: 'dark',
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var settings = _this9.parseCustomFormSettings(customForm.parser);
              if (!settings) {
                return false;
              } else {
                var updatedForm = {
                  entityId: _this9.entityId,
                  customFormId: customForm.customFormId,
                  customFormName: customForm.customFormName,
                  settingsJson: settings,
                  settingsTemplate: customForm.settingsTemplate,
                  parser: customForm.parser
                };
                _this9.editCustomForm(updatedForm);
              }
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'editCustomForm',
    value: function editCustomForm(customForm) {
      var _this10 = this;

      this.customFormsService.edit(customForm).then(function (response) {
        var form = (0, _lodash.find)(_this10.entity.customForms, function (o) {
          return o.customFormId === customForm.customFormId;
        });
        form.settingsJson = customForm.settingsJson;

        _this10.growl.success(customForm.customFormName + ' updated successfully', { ttl: 5000 });
      }).catch(function (err) {
        alert('Could not save custom form. Something went wrong.');
      });
    }
  }, {
    key: 'getStockProviderList',
    value: function getStockProviderList() {
      var stockProviderList = [];
      stockProviderList.push({ id: null, name: 'None', params: null });
      stockProviderList.push({ id: 1, name: 'DoneDeal', params: [{ key: 'dealerId', label: 'Dealer Id', value: null }] });
      stockProviderList.push({ id: 2, name: 'Cars Ireland', params: [{ key: 'dealerId', label: 'CarsIreland DealerId', value: null }] });
      stockProviderList.push({ id: 3, name: 'SIMI Stock Loader', params: [{ key: 'dealerId', label: 'StockLoader DealerId', value: null }] });
      stockProviderList.push({ id: 4, name: 'CarZone', params: [{ key: 'username', label: 'Username', value: null }, { key: 'password', label: 'Password', value: null }] });
      stockProviderList.push({ id: 5, name: 'Happy Dealer', params: [{ key: 'feedId', label: 'Feed Id', value: null }] });

      return stockProviderList;
    }
  }, {
    key: 'showEditStockProvider',
    value: function showEditStockProvider() {
      var _this11 = this;

      this._$scope.stockProviderList = this.getStockProviderList();
      this._$scope.errMsgs = null;
      this._$scope.changeProvider = function () {
        var selectedProvider = (0, _lodash.find)(_this11._$scope.stockProviderList, function (p) {
          return p.id === _this11._$scope.stockProviderViewModel.stockProvider;
        });
        _this11._$scope.stockProviderViewModel.params = selectedProvider.params;
        _this11._$scope.stockProviderViewModel.name = selectedProvider.name;
      };

      this._$scope.stockProviderViewModel = {
        entityId: this.entity.entityId,
        stockProvider: this.entity.stockProvider,
        params: JSON.parse(this.entity.stockProviderSettings),
        name: this.entity.stockProviderName
      };

      this.$ngConfirm({
        title: 'Stock Provider Settings',
        contentUrl: 'templates/admin/stockProviderTemplate',
        scope: this._$scope,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              return _this11.updateStockProvider();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'updateStockProvider',
    value: function updateStockProvider() {
      var _this12 = this;

      if (this._$scope.stockProviderViewModel.params) {
        var unfilled = (0, _lodash.filter)(this._$scope.stockProviderViewModel.params, function (s) {
          return !s.value;
        });

        if (unfilled.length) {
          this._$scope.errMsgs = unfilled.map(function (p) {
            return 'Please provide a value for ' + p.label;
          });
          return false;
        }
      }

      var stockProviderViewModel = {
        entityId: this.entity.entityId,
        stockProvider: null,
        stockProviderSettings: null
      };

      this.loadingService.showLoading('editEntity', 'Updating Stock Provider ...');

      if (this._$scope.stockProviderViewModel.stockProvider) {
        stockProviderViewModel.stockProvider = this._$scope.stockProviderViewModel.stockProvider;
        stockProviderViewModel.stockProviderSettings = (0, _stringify2.default)(this._$scope.stockProviderViewModel.params.map(function (p) {
          return { key: p.key, label: p.label, value: p.value };
        }));
      }

      this._entityService.updateStockProvider(stockProviderViewModel).then(function (response) {
        _this12.entity.stockProvider = stockProviderViewModel.stockProvider;
        _this12.entity.stockProviderName = _this12._$scope.stockProviderViewModel.name;
        _this12.entity.stockProviderSettings = stockProviderViewModel.stockProviderSettings;

        _this12.growl.success('Stock Provider updated successfully', { ttl: 5000 });
      }).finally(function () {
        editCtrl.loadingService.hideLoading('editEntity');
      });
    }
  }, {
    key: 'strToBool',
    value: function strToBool(value) {
      if (value === 'true') {
        return true;
      }

      return false;
    }
  }, {
    key: 'updateMeta',
    value: function updateMeta(entityMetaType, value) {
      var meta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
        return em.entityMetaType === entityMetaType;
      });

      if (meta) {
        meta.value = value;
      } else {
        this.entity.entityMeta.push({ entityMetaType: entityMetaType, value: value });
      }
    }
  }, {
    key: 'updateJsonMeta',
    value: function updateJsonMeta(entityMetaType, obj, fieldName, value) {
      var meta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
        return em.entityMetaType === entityMetaType;
      });

      if (meta) {
        obj[fieldName] = value;
        meta.value = (0, _angularUiRouter.toJson)(obj);
      } else {
        obj[fieldName] = value;
        this.entity.entityMeta.push({ entityMetaType: entityMetaType, value: (0, _angularUiRouter.toJson)(obj) });
      }
    }
  }, {
    key: 'getTelecomProviderList',
    value: function getTelecomProviderList() {
      var telecomProviderList = [];
      telecomProviderList.push({ id: null, name: 'None', params: null });
      telecomProviderList.push({ id: 1, name: 'Nuacom', params: [{ key: 'apiKey', label: 'Api Key', value: null }] });
      telecomProviderList.push({ id: 2, name: 'Call Metrics', params: [{ key: 'apiKey', label: 'Api Key', value: null }, { key: 'username', label: 'Username', value: null }, { key: 'password', label: 'Password', value: null }] });

      return telecomProviderList;
    }
  }, {
    key: 'showEditTelecomProvider',
    value: function showEditTelecomProvider() {
      var _this13 = this;

      this._$scope.telecomProviderList = this.getTelecomProviderList();
      this._$scope.errMsgs = null;
      this._$scope.changeProvider = function () {
        var selectedProvider = (0, _lodash.find)(_this13._$scope.telecomProviderList, function (p) {
          return p.id === _this13._$scope.telecomProviderViewModel.id;
        });
        _this13._$scope.telecomProviderViewModel.params = selectedProvider.params;
        _this13._$scope.telecomProviderViewModel.name = selectedProvider.name;
      };

      var telecomProviderMeta = (0, _lodash.find)(this.entity.entityMeta, function (em) {
        return em.entityMetaType === _this13.enums.ENTITY_META_TYPE.TelecomProvider;
      });
      if (telecomProviderMeta != null) {
        var jsonValue = JSON.parse(telecomProviderMeta.value);

        this._$scope.telecomProviderViewModel = {
          id: jsonValue.id,
          params: jsonValue.params,
          name: jsonValue.name
        };
      } else {
        this._$scope.telecomProviderViewModel = {
          id: null,
          params: null,
          name: "None"
        };
      }

      this.$ngConfirm({
        title: 'Telecom Provider Settings',
        contentUrl: 'templates/admin/telecomProviderTemplate',
        scope: this._$scope,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              return _this13.updateTelecomProvider();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'updateTelecomProvider',
    value: function updateTelecomProvider() {
      var _this14 = this;

      if (this._$scope.telecomProviderViewModel.params) {
        var unfilled = (0, _lodash.filter)(this._$scope.telecomProviderViewModel.params, function (s) {
          return !s.value;
        });

        if (unfilled.length) {
          this._$scope.errMsgs = unfilled.map(function (p) {
            return 'Please provide a value for ' + p.label;
          });
          return false;
        }
      }

      var telecomProvider = (0, _lodash.find)(this.entity.entityMeta, function (em) {
        return em.entityMetaType === _this14.enums.ENTITY_META_TYPE.TelecomProvider;
      });

      if (telecomProvider != null) {
        telecomProvider.value = (0, _angularUiRouter.toJson)(this._$scope.telecomProviderViewModel);
      } else {
        telecomProvider = {
          entityMetaType: this.enums.ENTITY_META_TYPE.TelecomProvider,
          value: (0, _angularUiRouter.toJson)(this._$scope.telecomProviderViewModel)
        };

        this.entity.entityMeta.push(telecomProvider);
      }

      this.entity.telecomProviderName = this._$scope.telecomProviderViewModel.name;
    }
  }]);
  return EditController;
}();

exports.default = EditController;


// WEBPACK FOOTER //
// ./client/app/components/admin/entity/edit/edit.controller.js